module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stores.length > -1) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    class: {
      list__gradient: _vm.showGradient
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list__header"
  }, [_vm._v(_vm._s(_vm.listHeaderNo) + " " + _vm._s(_vm.listHeaderSuffix))]), _vm._v(" "), _c('div', {
    staticClass: "list__items",
    attrs: {
      "id": "items"
    }
  }, _vm._l((_vm.stores), function(store, i) {
    return _c('div', {
      staticClass: "list__item",
      class: {
        'list__item--selected': _vm.selectedMarker && store.uuid === _vm.selectedMarker.uuid
      },
      on: {
        "click": function($event) {
          _vm.listClick(store, i)
        }
      }
    }, [_c('div', {
      staticClass: "list__name"
    }, [_c('div', {
      staticClass: "list__type",
      class: {
        'list__type--brand': store.monobrand && (store.monobrand === '1' || store.monobrand === true)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "list__details"
    }, [_vm._v(_vm._s(store.name))])]), _vm._v(" "), _c('div', {
      staticClass: "list__matrix"
    }, [_c('div', {
      staticClass: "list__address"
    }, [_vm._v(_vm._s(store.address) + ", " + _vm._s(store.city))]), _vm._v(" "), (store.distance) ? _c('div', {
      staticClass: "list__distance"
    }, [_vm._v(_vm._s(store.distance.replace('.', ',')) + " " + _vm._s(_vm.$t('matrix')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list__ipad"
    }, [_c('div', {
      staticClass: "list__show"
    }, [_vm._v(_vm._s(_vm.$t('showIpad')))])])])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b279d54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/List.vue
// module id = 406
// module chunks = 1